import { render, staticRenderFns } from "./supportJmModal.vue?vue&type=template&id=239a53f9&scoped=true"
import script from "./supportJmModal.vue?vue&type=script&lang=js"
export * from "./supportJmModal.vue?vue&type=script&lang=js"
import style0 from "./supportJmModal.vue?vue&type=style&index=0&id=239a53f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239a53f9",
  null
  
)

export default component.exports